import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const GetRotableFleet = createAsyncThunk(
    'partsales/rotablefleet',
    async()=>{
        const response = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/api/rotablefleet`
        ).catch((err) => {
            return {'status': err.status, 'data': 'failed'}
        })
        return {'status': response.status, 'data': response.data }
    }
)

export const GetRotableGroup = createAsyncThunk(
    'partsales/rotablegroup',
    async()=>{
        const response = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/api/rotablegroup` 
        ).catch((err) => {
            return {'status': err.status, 'data': 'failed'}
        })
        return {'status': response.status, 'data': response.data }
    }
)

export const GetRotableFleetGroup = createAsyncThunk(
    'partsales/rotablefleetgroup',
    async(params)=>{
        const response = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/api/rotablefleetgroup`,
            params, 
        ).catch((err) => {
            return {'status': err.status, 'data': 'failed'}
        })
        return {'status': response.status, 'data': response.data }
    }
)

export const getRotable = createAsyncThunk(
    'partsales/rotable',
    async (params) => {
        const response = await axios.post(
            `${process.env.REACT_APP_SERVER_URL}/api/rotable`,  
            params,
        ).catch((err) => {
            return {'status': err.status, 'data': 'failed'}
        })
        return {'status': response.status, 'data': response.data }
    }
)